import { render, staticRenderFns } from "./PaymentWizardOption.vue?vue&type=template&id=6e6f8648&scoped=true&"
import script from "./PaymentWizardOption.vue?vue&type=script&lang=js&"
export * from "./PaymentWizardOption.vue?vue&type=script&lang=js&"
import style0 from "./PaymentWizardOption.vue?vue&type=style&index=0&id=6e6f8648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6f8648",
  null
  
)

export default component.exports